/* eslint-disable import/no-cycle */
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { mobileApi } from 'features/app/baseApi';
import { navigatorApi } from 'features/navigator/api';
import notificationReducer from 'features/notifications/notificationsSlice';
import userInfoReducer from 'features/user/userInfoSlice';
import appReducer from 'features/app/appSlice';

const store = configureStore({
  reducer: {
    notifications: notificationReducer,
    userInfo: userInfoReducer,
    app: appReducer,
    [mobileApi.reducerPath]: mobileApi.reducer,
    [navigatorApi.reducerPath]: navigatorApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    mobileApi.middleware,
    navigatorApi.middleware,
  ),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType, // eslint-disable-line @typescript-eslint/indent
  RootState, // eslint-disable-line @typescript-eslint/indent
  unknown, // eslint-disable-line @typescript-eslint/indent
  Action<string> // eslint-disable-line @typescript-eslint/indent
>;

export default store;
